import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;

export class networkGroupsList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;

    protected getTemplateHtml(): string {

        return  `
                <div class="list-header margin-top w-justify">
                    <div class="w-left">
                        <button data-bind="click: onClickAdd" class="btn secondary icon i-add" type="button">Add Network Group</button>
                    </div>
                    <div class="w-left">
                        ${ this.filter.getHtmlBuild() }
                    </div>
                    <div class="w-right">
                        ${ this.pagination.getHtmlBuild() }
                    </div>
                </div>
         
                <div class="w-list-results"  id="list-results">
                    <table class="list-results">
                        ${ this.resultInfos.getHtmlBuild() }
                        <thead>
                            <input data-bind="value: orderBy" type="hidden">
                            <input data-bind="value: orderByDirection" type="hidden">
                            <tr>
                                <th><span data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }" class="icon list-sort-none">Id</span></th>
                                <th><span data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }" class="icon list-sort-none">Name</span></th>
                                <th><span data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }" class="icon list-sort-none">Creation Date</span></th>
                                <th><span data-bind="event: { click: onClickReorder.bind($data, 'isDeleted') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }" class="icon list-sort-none">Soft Delete</span></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: networkGroups">        
                            <tr class="cursor" data-bind="click: $parent.onClickView">
                                <td class="group_id"><span data-bind="text: id"></span></td>
                                <td class="group_name"><span data-bind="text: name"></span></td>
                                <td class="group_sequence"><span data-bind="text: dateCreated"></span></td>
                                <td class="align-left"><button class="btn icon border only-icon icon i-delete" type="button" data-bind="click: $parent.onClickDelete, clickBubble: false"></button></td>
                            </tr>                 
                        <tbody>
                        <tfoot>
                        </tfoot>
                    </table>
                </div>
            `;
    }

    protected initPartial(): void {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {
        return "networkGroupList_template";
    }

    public resetPageNumber(): void {
        this.pagination.getTemplateViewModel().pageNumber(1);
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the view model data/ functions
        let me = this;
        return {
            orderBy: ko.observable("name"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("name_ASC"),
            networkGroups: ko.observableArray([]),
            onClickReorder: function (value, data, event) {
                me.onClickReorder(value, data, event);
            },
            onClickView: function (data, event) {
                me.onClickView(data.id);
            },
            onClickAdd: function (data, event) {
                me.onClickAdd();
            },
            onClickDelete: function (data, event) {
                me.onClickDelete(data.id);
            }
        };
    }

    //
    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filter: {
                keyword: this.getTemplateViewModel().filter.filterKeyword
            }
        }
    }

    /**
     *
     * @param value
     * @param data
     * @param event
     */
    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());
        this.caller.networkGroupsListReorder();
    }

    /**
     *
     * @param id
     */
    public onClickView(id: number): void {
        this.caller.viewNetworkGroup(id);
    }

    public onClickAdd(): void {
        this.caller.addNetworkGroup();
    }

    public onClickDelete(groupId: number): void {

        this.caller.deleteNetworkGroup(groupId);
    }

    /**
     *
     * @param networkGroups
     */
    public setNetworkGroups(networkGroups: Array<{ id: number, name: string, dateCreated: string}>): void {

        this.getTemplateViewModel().networkGroups(networkGroups);
    }

    /**
     *
     * @param nbResults
     * @param nbPages
     * @param execTime
     */
    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setPaginationTotalCount(totalCount: number):  void {
        this.pagination.setNumberItemToPaginate(totalCount);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/networkGroupsList_template.ts